

// import React, { useEffect, useRef, useState } from "react";
// import MySvgButtonPlus from "../../UsefulComponent/MySvgButtonPlus";

// const DotsVertical = (props) => (
//   <svg width="20" height="20" viewBox="0 0 24 24" {...props} aria-hidden="true">
//     <circle cx="12" cy="5"  r="2" fill="currentColor" />
//     <circle cx="12" cy="12" r="2" fill="currentColor" />
//     <circle cx="12" cy="19" r="2" fill="currentColor" />
//   </svg>
// );

// const Sousmenu = ({
//   selectedCollectionLive,
//   selectedCollectionIsDefault,
//   selectedCollectionIsPublic,
//   selectedCollectionTitle,
//   defaultWatchlist,
//   handleChangeCollectionLive,
//   handleGroupAction,
//   handleSetAsDefault,
//   handleCollectionPublicClick,
//   handleCopyToClipboard,
//   isValidStringForDeleteCollection,
//   cardGridType,
//   userId,
//   collections,
//   t,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);          // mobile list
//   const [menuFor, setMenuFor] = useState(null);         // which tab owns the menu (ListId or null)
//   const triggerRef = useRef(null);
//   const menuRef = useRef(null);


//     const openCreate = () =>
//     handleGroupAction({ target: { value: "actionCreateNewCollection" } });
//   // close on outside click / ESC
//   useEffect(() => {
//     if (!menuFor) return;
//     const onDoc = (e) => {
//       const trg = triggerRef.current;
//       const box = menuRef.current;
//       if (box && !box.contains(e.target) && trg && !trg.contains(e.target)) {
//         setMenuFor(null);
//       }
//     };
//     const onEsc = (e) => e.key === "Escape" && setMenuFor(null);
//     document.addEventListener("mousedown", onDoc);
//     document.addEventListener("keydown", onEsc);
//     return () => {
//       document.removeEventListener("mousedown", onDoc);
//       document.removeEventListener("keydown", onEsc);
//     };
//   }, [menuFor]);

//   const canRename = isValidStringForDeleteCollection(selectedCollectionLive);
//   const canDelete =
//     canRename &&
//     selectedCollectionLive !== defaultWatchlist &&
//     !selectedCollectionIsDefault;
//   const canSetDefault = canDelete && cardGridType === "CardGridSell";

//   const onAction = (val) => {
//     setMenuFor(null);
//     handleGroupAction({ target: { value: val } });
//   };

//   const TabButton = ({ active, onClick, children }) => (
//     <button className={active ? "active" : "inactive"} onClick={onClick}>
//       {children}
//     </button>
//   );

//   return (
//     <div className="sousmenus-wrapper">
//       <div className="sousmenus">
//         <TabButton
//           active={!selectedCollectionLive && selectedCollectionLive !== 0}
//           onClick={() => handleChangeCollectionLive("", "", "", 0, 0)}
//         >
//           {t("Show all cards")}
//         </TabButton>

//         {cardGridType === "CardGridSell" && userId && (
//           <TabButton
//             active={selectedCollectionLive === "0"}
//             onClick={() =>
//               handleChangeCollectionLive("0","MyListings",`${t("My listings")} (100)`,0,0)
//             }
//           >
//             {t("My listings")}
//           </TabButton>
//         )}

//         {collections.map((c) => {
//           const active = selectedCollectionLive === c.ListId;
//           const hereOpen = menuFor === c.ListId;

//           return (
//             <div key={c.ListId} className="tab-with-actions">
//               <TabButton
//                 active={active}
//                 onClick={() =>
//                   handleChangeCollectionLive(
//                     c.ListId, c.Title,
//                     `${c.Title} (${c.collectionCount})`,
//                     c.isDefault, c.Public
//                   )
//                 }
//               >
//                 {`${c.Title} (${c.collectionCount})`}
//                 {c.isDefault ? ` (${t("Default")})` : ""}
//               </TabButton>

//               {active && (
//                 <button
//                   ref={hereOpen ? triggerRef : null}
//                   className="tab-actions-trigger"
//                   aria-haspopup="menu"
//                   aria-expanded={hereOpen}
//                   title={t("Actions")}
//                   onClick={() => setMenuFor(hereOpen ? null : c.ListId)}
//                 >
//                   <DotsVertical />
//                 </button>
//               )}

//               {/* ⬇️ Menu renders INSIDE this tab container */}
//               {hereOpen && (
//                 <div className="watchlist-menu" ref={menuRef} role="menu">
//                   {isValidStringForDeleteCollection(selectedCollectionLive) && (
//                     <>
//                       <button role="menuitem" onClick={() => onAction("actionRenameCollection")}>
//                         ✏️ {t("Rename")}
//                       </button>
//                       {selectedCollectionLive !== defaultWatchlist &&
//                         !selectedCollectionIsDefault && (
//                           <button
//                             role="menuitem"
//                             onClick={() => onAction("actionDeleteCollectionOrWatchList")}
//                           >
//                             ❌ {t("Delete watchlist")}
//                           </button>
//                         )}
//                       {selectedCollectionLive !== defaultWatchlist &&
//                         !selectedCollectionIsDefault &&
//                         cardGridType === "CardGridSell" && (
//                           <button
//                             role="menuitem"
//                             onClick={() => {
//                               setMenuFor(null);
//                               handleSetAsDefault(selectedCollectionLive);
//                             }}
//                           >
//                             {t("Set this as default")}
//                           </button>
//                         )}

//                       <div className="menu-sep" />

                      
//              <label
//   className="menu-check"
//   role="menuitemcheckbox"
//   aria-checked={!!selectedCollectionIsPublic}
// >
//   <input
//     type="checkbox"
//     checked={!!selectedCollectionIsPublic}
//     onChange={(e) => handleCollectionPublicClick(e.target.checked)}
//   />
//   <span className="menu-check-text">
//     {t("Make")} “{selectedCollectionTitle}” {t("Public")}
//   </span>
// </label>

// {selectedCollectionIsPublic && (
//   <button role="menuitem" onClick={handleCopyToClipboard}>
//     {t("Export / Copy link")}
//   </button>
// )}
//                     </>
//                   )}
//                 </div>
//               )}
//             </div>
//           );
//         })}

//         <MySvgButtonPlus
//           onClickDo={() =>
//             handleGroupAction({ target: { value: "actionCreateNewCollection" } })
//           }
//           withBox={false}
//         />
//       </div>
//       {/* Mobile toggle */}
//       <div className="sousmenu-mobile-wrapper">
//         <button className="hamburger-toggle" onClick={() => setIsOpen(!isOpen)}>
//           ☰ {t("Collections")}
//         </button>
//       </div>

//       {/* Mobile dropdown */}
//       {isOpen && (
//         <div className="sousmenu-mobile-dropdown">
//           <TabButton
//             active={!selectedCollectionLive && selectedCollectionLive !== 0}
//             onClick={() => {
//               handleChangeCollectionLive("", "", "", 0, 0);
//               setIsOpen(false);
//             }}
//           >
//             {t("Show all cards")}
//           </TabButton>

//           {cardGridType === "CardGridSell" && userId && (
//             <TabButton
//               active={selectedCollectionLive === "0"}
//               onClick={() => {
//                 handleChangeCollectionLive(
//                   "0",
//                   "MyListings",
//                   `${t("My listings")} (100)`,
//                   0,
//                   0
//                 );
//                 setIsOpen(false);
//               }}
//             >
//               {t("My listings")}
//             </TabButton>
//           )}

//           {collections.map((c) => (
//             <TabButton
//               key={c.ListId}
//               active={selectedCollectionLive === c.ListId}
//               onClick={() => {
//                 handleChangeCollectionLive(
//                   c.ListId,
//                   c.Title,
//                   `${c.Title} (${c.collectionCount})`,
//                   c.isDefault,
//                   c.Public
//                 );
//                 setIsOpen(false);
//               }}
//             >
//               {`${c.Title} (${c.collectionCount})`}
//               {c.isDefault ? ` (${t("Default")})` : ""}
//             </TabButton>
//           ))}

//           <MySvgButtonPlus
//             onClickDo={() => {
//               openCreate();
//               setIsOpen(false);
//             }}
//             withBox={false}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default Sousmenu;

// src/components/GridViewMain/Sousmenu.jsx
import React, { useEffect, useRef, useState, useCallback } from "react";
import { createPortal } from "react-dom";
import MySvgButtonPlus from "../../UsefulComponent/MySvgButtonPlus";

const DotsVertical = (props) => (
  <svg width="25" height="25" viewBox="0 0 24 24" {...props} aria-hidden="true">
    <circle cx="12" cy="5" r="2" fill="currentColor" />
    <circle cx="12" cy="12" r="2" fill="currentColor" />
    <circle cx="12" cy="19" r="2" fill="currentColor" />
  </svg>
);

const Chevron = ({ dir = "left" }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    {dir === "left" ? (
      <path d="M15 6L9 12l6 6" stroke="currentColor" strokeWidth="2" fill="none" />
    ) : (
      <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" fill="none" />
    )}
  </svg>
);

export default function Sousmenu({
  selectedCollectionLive,
  selectedCollectionIsDefault,
  selectedCollectionIsPublic,
  selectedCollectionTitle,
  defaultWatchlist,

  handleChangeCollectionLive,
  handleGroupAction,
  handleSetAsDefault,
  handleCollectionPublicClick,
  handleCopyToClipboard,
  isValidStringForDeleteCollection,

  cardGridType,
  userId,
  collections,
  t,
}) {
  // Which tab owns the menu (ListId) or null
  const [menuFor, setMenuFor] = useState(null);

  // Anchor element and computed position for the portal menu
  const [triggerEl, setTriggerEl] = useState(null);
  const menuRef = useRef(null);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0, width: 240 });

  // carousel refs/state (mobile)
  const rowRef = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  // Compute a good on-screen position for the dropdown
  const computeMenuPos = useCallback(
    (el) => {
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const vw = window.innerWidth;
      const desiredWidth = 240; // matches min-width in CSS; tweak if you change styles
      const gap = 8;

      // default: align right edge of menu with right edge of trigger
      let left = rect.right - desiredWidth;
      let top = rect.bottom + gap;

      // keep within viewport (8px margins)
      const minLeft = 8;
      const maxLeft = vw - desiredWidth - 8;
      left = Math.max(minLeft, Math.min(left, maxLeft));

      setMenuPos({ top, left, width: desiredWidth });
    },
    [setMenuPos]
  );

  // Open/close from dots button
  const toggleMenu = (listId, e) => {
    if (menuFor === listId) {
      setMenuFor(null);
      setTriggerEl(null);
      return;
    }
    const el = e.currentTarget;
    setTriggerEl(el);
    computeMenuPos(el);
    setMenuFor(listId);
  };

  // Close on outside click / ESC
  useEffect(() => {
    if (!menuFor) return;

    const onDoc = (e) => {
      const box = menuRef.current;
      // If click is outside both the menu and the trigger, close
      if (
        box &&
        !box.contains(e.target) &&
        triggerEl &&
        !triggerEl.contains(e.target)
      ) {
        setMenuFor(null);
        setTriggerEl(null);
      }
    };
    const onEsc = (e) => e.key === "Escape" && (setMenuFor(null), setTriggerEl(null));

    document.addEventListener("mousedown", onDoc, true);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDoc, true);
      document.removeEventListener("keydown", onEsc);
    };
  }, [menuFor, triggerEl]);

  // Keep menu aligned if viewport or row scrolls/resizes
  useEffect(() => {
    if (!menuFor || !triggerEl) return;

    const onReposition = () => computeMenuPos(triggerEl);

    window.addEventListener("resize", onReposition);
    window.addEventListener("scroll", onReposition, true); // capture scrolls from any ancestor
    rowRef.current?.addEventListener("scroll", onReposition, { passive: true });

    return () => {
      window.removeEventListener("resize", onReposition);
      window.removeEventListener("scroll", onReposition, true);
      rowRef.current?.removeEventListener("scroll", onReposition);
    };
  }, [menuFor, triggerEl, computeMenuPos]);

  const openCreate = () =>
    handleGroupAction({ target: { value: "actionCreateNewCollection" } });

  // Enable/disable mobile arrows based on scroll
  const updateArrows = useCallback(() => {
    const el = rowRef.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 0);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  }, []);
  useEffect(() => {
    updateArrows();
    const el = rowRef.current;
    if (!el) return;
    const onScroll = () => updateArrows();
    const onResize = () => updateArrows();
    el.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
    return () => {
      el.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, [collections, selectedCollectionLive, updateArrows]);

  const scrollByAmt = (amt) => {
    rowRef.current?.scrollBy({ left: amt, behavior: "smooth" });
  };

  const canRename = isValidStringForDeleteCollection(selectedCollectionLive);
  const canDelete =
    canRename &&
    selectedCollectionLive !== defaultWatchlist &&
    !selectedCollectionIsDefault;
  const canSetDefault = canDelete && cardGridType === "CardGridSell";

  const onAction = (val) => {
    setMenuFor(null);
    setTriggerEl(null);
    handleGroupAction({ target: { value: val } });
  };

  const TabButton = ({ active, onClick, children }) => (
    <button className={active ? "active" : "inactive"} onClick={onClick}>
      {children}
    </button>
  );

  return (
    <div className="sousmenus-wrapper">
      {/* Viewport with scrollable row (works as carousel on mobile) */}
      <div className="sousmenus-viewport">
        {/* mobile nav buttons (show only when needed, via CSS + state) */}
        <button
          className={`carousel-nav left ${canLeft ? "show" : ""}`}
          onClick={() => scrollByAmt(-220)}
          aria-label="Scroll left"
        >

          <Chevron dir="left" />
        </button>


        <div className="sousmenus" ref={rowRef}>
          <div className="tab-with-actions">
            <TabButton
              active={!selectedCollectionLive && selectedCollectionLive !== 0}
              onClick={() => handleChangeCollectionLive("", "", "", 0, 0)}
            >
              {t("Show all cards")}
            </TabButton>
          </div>

          {cardGridType === "CardGridSell" && userId && (
            <div className="tab-with-actions">
              <TabButton
                active={selectedCollectionLive === "0"}
                onClick={() =>
                  handleChangeCollectionLive(
                    "0",
                    "MyListings",
                    `${t("My listings")} (100)`,
                    0,
                    0
                  )
                }
              >
                {t("My listings")}
              </TabButton>
            </div>
          )}

          {collections.map((c) => {
            const active = selectedCollectionLive === c.ListId;
            const hereOpen = menuFor === c.ListId;

            return (
              <div
                key={c.ListId}
                className={`tab-with-actions ${active ? "has-menu" : ""}`}
              >
                <TabButton
                  active={active}
                  onClick={() =>
                    handleChangeCollectionLive(
                      c.ListId,
                      c.Title,
                      `${c.Title} (${c.collectionCount})`,
                      c.isDefault,
                      c.Public
                    )
                  }
                >
                  {`${c.Title} (${c.collectionCount})`}
                  {c.isDefault ? ` (${t("Default")})` : ""}
                </TabButton>

                {active && (
                  <button
                    className="tab-actions-trigger slim"
                    aria-haspopup="menu"
                    aria-expanded={hereOpen}
                    title={t("Actions")}
                    style={{padding:'0'}}
                    onClick={(e) => toggleMenu(c.ListId, e)}
                  >
                    <DotsVertical />
                  </button>
                )}
              </div>
            );
          })}

          <div className="tab-with-actions">
            <MySvgButtonPlus onClickDo={openCreate} withBox={false} />
          </div>
        </div>

        <button
          className={`carousel-nav right ${canRight ? "show" : ""}`}
          onClick={() => scrollByAmt(220)}
          aria-label="Scroll right"
        >
          <Chevron dir="right" />
        </button>
      </div>

      {/* Portal dropdown (renders once per open menu) */}
      {menuFor !== null &&
        createPortal(
          <div
            ref={menuRef}
            className="watchlist-menu portal"
            role="menu"
            style={{
              position: "fixed",
              top: `${menuPos.top}px`,
              left: `${menuPos.left}px`,
              width: `${menuPos.width}px`,
              zIndex: 10000,
            }}
          >
            {canRename && (
              <>
                <button role="menuitem" onClick={() => onAction("actionRenameCollection")}>
                  ✏️ {t("Rename")}
                </button>

                {canDelete && (
                  <button
                    role="menuitem"
                    onClick={() => onAction("actionDeleteCollectionOrWatchList")}
                  >
                    ❌ {t("Delete watchlist")}
                  </button>
                )}

                {canSetDefault && (
                  <button
                    role="menuitem"
                    onClick={() => {
                      setMenuFor(null);
                      setTriggerEl(null);
                      handleSetAsDefault(selectedCollectionLive);
                    }}
                  >
                    {t("Set this as default")}
                  </button>
                )}

                <div className="menu-sep" />
                <label
                  className="menu-check"
                  role="menuitemcheckbox"
                  aria-checked={!!selectedCollectionIsPublic}
                >
                  <input
                    type="checkbox"
                    checked={!!selectedCollectionIsPublic}
                    onChange={(e) => handleCollectionPublicClick(e.target.checked)}
                  />
                  <span className="menu-check-text">
                    {t("Make")} “{selectedCollectionTitle}” {t("Public")}
                  </span>
                </label>

                {selectedCollectionIsPublic && (
                  <button role="menuitem" onClick={handleCopyToClipboard}>
                    {t("Export / Copy link")}
                  </button>
                )}
              </>
            )}
          </div>,
          document.body
        )}
    </div>
  );
}
